import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings.js";
import DesignIllustration2 from "../../images/babykraken_logo.png";
import LogoText from "../../images/babykraken_logotext-min.png";
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;



const ImageColumn = tw.div`flex justify-center lg:justify-center items-center`;



const TextColumn = styled(Column)(props => [
  tw`md:w-6/12 mt-8 md:mt-0`,
  props.textOnLeft ? tw`md:mr-8 lg:mr-16 md:order-first` : tw`md:ml-8 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-cover bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8`;

const Heading = tw(SectionHeading)`text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 mt-4`

const Statistics = tw.div`mt-6 lg:mt-8 xl:mt-16 flex flex-wrap`
const Statistic = tw.div`text-lg sm:text-2xl lg:text-3xl w-1/2 mt-4 lg:mt-10 text-center md:text-left`
const Value = tw.div`font-bold text-green-500`
const Key = tw.div`font-medium text-gray-700`

export default ({textOnLeft = false}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  //Change the statistics variable as you like, add or delete objects
  const statistics = [
    {
      key: "1 Quadrillion",
      value: "Total Supply",
    },
    {
      key: "$KRAKBABY",
      value: "Ticker",
    },
    {
      key: "670,903,954,802",
      value: "Presale Price",
    },
    {
      key: "670,903,954,802",
      value: "Pancakeswap Price",
    }
  ]


  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
        <img src={DesignIllustration2} alt="Design Illustration" />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Heading>BabyKraken's buyback & burn</Heading>
            <img src={LogoText} alt="Design Illustration" />
            <Description>BabyKraken has improved on the EverRise buyback mechanism with anti-botting measures. </Description>


<Description>BabyKraken buybacks have a lower limit under which the buyback will cover 100% of the amount sold, and nothing more. Transactions above the threshold will not be impacted by this measure.
For example, if you sell 0.01 BNB worth of BabyKraken when the buyback threshold is set at 0.1 BNB, the buyback will only cover 0.01 BNB.
</Description>

<Description>In addition to this, buybacks below the threshold have a 3 second cooldown based on block-timestamps.
</Description>

<Description>
This protects our buyback fund from being exploited the way that EverRise has been, with thousands of micro-transactions triggering thousands of 0.1BNB buybacks. Read our wiki (LINK) for a detailed breakdown of our buyback mechanism.</Description>
            <Statistics>
              {statistics.map((statistic, index) => (
              <Statistic key={index}>
                <Value>{statistic.value}</Value>
                <Key>{statistic.key}</Key>
              </Statistic>
              ))}
            </Statistics>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
